import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-contanten',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-contanten.component.html',
  styleUrl: './tekst-contanten.component.scss',
})
export class TekstContantenComponent {}
